import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const YoutubePauseCommand = JSON.stringify({ event: 'command', func: 'pauseVideo' })
const VimeoPauseCommand = JSON.stringify({ method: 'pause' })

function VideoSlide({ slide: video, isInView }) {
  const videoPlayerRef = useRef()
  const isYouTube = video.type === 'YouTube'

  const url = isYouTube ? `${video.url}&enablejsapi=1` : `${video.url}&api=1`

  useEffect(() => {
    if (videoPlayerRef.current && !isInView)
      videoPlayerRef.current.contentWindow.postMessage(isYouTube ? YoutubePauseCommand : VimeoPauseCommand, '*')
  }, [isInView, isYouTube])

  return (
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    <iframe
      ref={videoPlayerRef}
      className="dali-plugin-video-content"
      src={url}
      frameBorder="0"
      allowFullScreen={true}
    />
  )
}

VideoSlide.propTypes = {
  slide: PropTypes.object.isRequired,
  isInView: PropTypes.bool.isRequired,
}

export default VideoSlide
